import type { DataViewVisualizationKey } from 'cadenza/workbook/api/data-view-visualization-key';

// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const COMBINATION_CHART_VISUALIZATION_TYPES_VALUES = [
  'COLUMN_CHART',
  'LINE_CHART',
  'MULTI_LINE_CHART',
] as const;

/** @see net/disy/cadenza/workbook/model/CombinationChartVisualizationTypes.java */
export type CombinationChartVisualizationTypes = (typeof COMBINATION_CHART_VISUALIZATION_TYPES_VALUES)[number];

export const CombinationChartVisualizationTypes = {
  values: COMBINATION_CHART_VISUALIZATION_TYPES_VALUES as readonly CombinationChartVisualizationTypes[],
} as const;

// </GENERATED-CODE>

const COMBINATION_CHART_DATA_VIEW_VISUALIZATION_KEYS_VALUES = COMBINATION_CHART_VISUALIZATION_TYPES_VALUES.map(key => 'CHART.' + key) as DataViewVisualizationKey[];

export type CombinationChartDataViewVisualizationKeys = (typeof COMBINATION_CHART_DATA_VIEW_VISUALIZATION_KEYS_VALUES)[number];

export const CombinationChartDataViewVisualizationKeys = {
  values: COMBINATION_CHART_DATA_VIEW_VISUALIZATION_KEYS_VALUES as readonly CombinationChartDataViewVisualizationKeys[],
} as const;
